import Pin from './platform/unit/Pin'
import Worker from './platform/process/Worker'
import Write from './platform/method/value/Write'
import Read0 from './platform/method/value/Read0'
import Read from './platform/method/value/Read'
import Start from './platform/method/process/Start'
import New from './platform/method/process/New'
import FromUnitBundle from './platform/method/process/FromUnitBundle'
import FromBundle from './platform/method/process/FromBundle'
import Boot from './platform/method/process/Boot'
import Subscribe from './platform/method/object/Subscribe'
import Set0 from './platform/method/object/Set0'
import Set from './platform/method/object/Set'
import Keys from './platform/method/object/Keys'
import HasKey from './platform/method/object/HasKey'
import Get1 from './platform/method/object/Get1'
import Get0 from './platform/method/object/Get0'
import Delete from './platform/method/object/Delete'
import DeepSet from './platform/method/object/DeepSet'
import DeepHasKey from './platform/method/object/DeepHasKey'
import DeepGet0 from './platform/method/object/DeepGet0'
import DeepGet from './platform/method/object/DeepGet'
import DeepDelete from './platform/method/object/DeepDelete'
import Append from './platform/method/form/Append'
import StopPropagation from './platform/method/component/StopPropagation'
import Focus from './platform/method/component/Focus'
import Click from './platform/method/component/Click'
import Blur from './platform/method/component/Blur'
import AttachText from './platform/method/component/AttachText'
import AttachDropTarget from './platform/method/component/AttachDropTarget'
import Shift from './platform/method/array/Shift'
import Put0 from './platform/method/array/Put0'
import Pop from './platform/method/array/Pop'
import Length0 from './platform/method/array/Length0'
import IndexOf from './platform/method/array/IndexOf'
import At1 from './platform/method/array/At1'
import At0 from './platform/method/array/At0'
import Append0 from './platform/method/array/Append'
import ParentChild from './platform/meta/component/ParentChild'
import Children from './platform/meta/component/Children'
import Child from './platform/meta/component/Child'
import TextField from './platform/component/value/TextField'
import TextArea from './platform/component/value/TextArea'
import Text from './platform/component/value/Text'
import Slider from './platform/component/value/Slider'
import Select from './platform/component/value/Select'
import RadioField from './platform/component/value/RadioField'
import PasswordField from './platform/component/value/PasswordField'
import Option from './platform/component/value/Option'
import NumberField from './platform/component/value/NumberField'
import FileField from './platform/component/value/FileField'
import Fieldset from './platform/component/value/Fieldset'
import EditableField from './platform/component/value/EditableField'
import Color from './platform/component/value/Color'
import Checkbox from './platform/component/value/Checkbox'
import View from './platform/component/svg/View'
import Use from './platform/component/svg/Use'
import TextPath from './platform/component/svg/TextPath'
import Text0 from './platform/component/svg/Text'
import TSpan from './platform/component/svg/TSpan'
import Symbol from './platform/component/svg/Symbol'
import Switch from './platform/component/svg/Switch'
import Stop from './platform/component/svg/Stop'
import Set1 from './platform/component/svg/Set'
import SVG from './platform/component/svg/SVG'
import Rect from './platform/component/svg/Rect'
import RadialGradient from './platform/component/svg/RadialGradient'
import Polyline from './platform/component/svg/Polyline'
import Polygon from './platform/component/svg/Polygon'
import Pattern from './platform/component/svg/Pattern'
import Path from './platform/component/svg/Path'
import Mask from './platform/component/svg/Mask'
import Marker from './platform/component/svg/Marker'
import MPath from './platform/component/svg/MPath'
import LinearGradient from './platform/component/svg/LinearGradient'
import Line from './platform/component/svg/Line'
import Image from './platform/component/svg/Image'
import Group from './platform/component/svg/Group'
import ForeignObject from './platform/component/svg/ForeignObject'
import FilterEffectTurbulence from './platform/component/svg/FilterEffectTurbulence'
import FilterEffectTile from './platform/component/svg/FilterEffectTile'
import FilterEffectSpotLight from './platform/component/svg/FilterEffectSpotLight'
import FilterEffectSpecularLighting from './platform/component/svg/FilterEffectSpecularLighting'
import FilterEffectPointLight from './platform/component/svg/FilterEffectPointLight'
import FilterEffectOffset from './platform/component/svg/FilterEffectOffset'
import FilterEffectMorphology from './platform/component/svg/FilterEffectMorphology'
import FilterEffectMergeNode from './platform/component/svg/FilterEffectMergeNode'
import FilterEffectMerge from './platform/component/svg/FilterEffectMerge'
import FilterEffectImage from './platform/component/svg/FilterEffectImage'
import FilterEffectGaussianBlur from './platform/component/svg/FilterEffectGaussianBlur'
import FilterEffectFlood from './platform/component/svg/FilterEffectFlood'
import FilterEffectDropShadow from './platform/component/svg/FilterEffectDropShadow'
import FilterEffectDistantLight from './platform/component/svg/FilterEffectDistantLight'
import FilterEffectDisplacementMap from './platform/component/svg/FilterEffectDisplacementMap'
import FilterEffectDiffuseLighting from './platform/component/svg/FilterEffectDiffuseLighting'
import FilterEffectConvolveMatrix from './platform/component/svg/FilterEffectConvolveMatrix'
import FilterEffectComponentTransfer from './platform/component/svg/FilterEffectComponentTransfer'
import FilterEffectColorMatrix from './platform/component/svg/FilterEffectColorMatrix'
import FilterEffectBlend from './platform/component/svg/FilterEffectBlend'
import Filter from './platform/component/svg/Filter'
import Ellipse from './platform/component/svg/Ellipse'
import Defs from './platform/component/svg/Defs'
import ClipPath from './platform/component/svg/ClipPath'
import Circle from './platform/component/svg/Circle'
import AnimateTransform from './platform/component/svg/AnimateTransform'
import AnimateMotion from './platform/component/svg/AnimateMotion'
import Animate from './platform/component/svg/Animate'
import Video from './platform/component/media/Video'
import Image0 from './platform/component/media/Image'
import Audio from './platform/component/media/Audio'
import Canvas from './platform/component/canvas/Canvas'
import Transcend from './platform/component/app/Transcend'
import Search from './platform/component/app/Search'
import Resize from './platform/component/app/Resize'
import PhoneKeyboardKey from './platform/component/app/PhoneKeyboardKey'
import PhoneKeyboard from './platform/component/app/PhoneKeyboard'
import GUIControlKeyboard from './platform/component/app/GUIControlKeyboard'
import GUIControl from './platform/component/app/GUIControl'
import GUI from './platform/component/app/GUI'
import Editor from './platform/component/app/Editor'
import Editor0 from './platform/component/Body'
import Editor1 from './platform/component/Anchor'
import Editor2 from './platform/component/Bold'
import Editor3 from './platform/component/Button'
import Editor4 from './platform/component/Details'
import Editor5 from './platform/component/Div'
import Editor6 from './platform/component/Form'
import Editor7 from './platform/component/Header1'
import Editor8 from './platform/component/Header2'
import Editor9 from './platform/component/Header3'
import Editor10 from './platform/component/Label'
import Editor11 from './platform/component/Paragraph'
import Editor12 from './platform/component/Span'
import Editor13 from './platform/component/Summary'
import Editor14 from './platform/component/Table'
import Editor15 from './platform/component/TableData'
import Editor16 from './platform/component/TableHeader'
import Editor17 from './platform/component/TableRow'
import Editor18 from './platform/api/media/image/Image'
import Datum from './platform/component/app/Datum'
import Class from './platform/component/app/Class'
import Bot from './platform/component/app/Bot'
import Zoom from './platform/component/Zoom'
import Wrap from './platform/component/Wrap'
import Section from './platform/component/Section'
import Render from './platform/component/Render'
import Parent from './platform/component/Parent'
import Nav from './platform/component/Nav'
import Inherit from './platform/component/Inherit'
import Icon from './platform/component/Icon'
import Frame from './platform/component/Frame'
import Footer from './platform/component/Footer'
import Article from './platform/component/Article'
import Icons from './platform/asset/Icons'
import WakeLock from './platform/api/wakelock/WakeLock'
import vibrate from './platform/api/vibration/vibrate'
import Encode0 from './platform/api/text/method/Encode0'
import Encode from './platform/api/text/method/Encode'
import Decode from './platform/api/text/method/Decode'
import TextEncoder from './platform/api/text/TextEncoder'
import TextDecoder from './platform/api/text/TextDecoder'
import SessionStorage from './platform/api/storage/SessionStorage'
import LocalStorage from './platform/api/storage/LocalStorage'
import LocalObject from './platform/api/storage/LocalObject'
import TextToSpeech from './platform/api/speech/TextToSpeech'
import SpeechToText from './platform/api/speech/SpeechToText'
import Share from './platform/api/share/Share'
import ScrollIntoView from './platform/api/scroll/ScrollIntoView'
import Scroll from './platform/api/scroll/Scroll'
import BroadcastChannel from './platform/api/process/BroadcastChannel'
import TogglePopover from './platform/api/popover/TogglePopover'
import ShowPopover from './platform/api/popover/ShowPopover'
import HidePopover from './platform/api/popover/HidePopover'
import SetPointerCapture from './platform/api/pointer/SetPointerCapture'
import PeerTransmitter from './platform/api/peer/PeerTransmitter'
import PeerReceiver from './platform/api/peer/PeerReceiver'
import Tags from './platform/api/parser/Tags'
import DomToUnit from './platform/api/parser/DomToUnit'
import SizeObserver from './platform/api/observer/SizeObserver'
import PositionObserver from './platform/api/observer/PositionObserver'
import Observe from './platform/api/observer/Observe'
import IntersectionObserver from './platform/api/observer/IntersectionObserver'
import Show from './platform/api/notification/Show'
import Notification from './platform/api/notification/Notification'
import Close from './platform/api/notification/Close'
import ReadableStream from './platform/api/network/stream/ReadableStream'
import WebSocket from './platform/api/network/WebSocket'
import ToText from './platform/api/network/ToText'
import ToJson from './platform/api/network/ToJson'
import ToBlob from './platform/api/network/ToBlob'
import ToArrayBuffer from './platform/api/network/ToArrayBuffer'
import Fetch from './platform/api/network/Fetch'
import EventSource from './platform/api/network/EventSource'
import ImageToBitmap from './platform/api/media/image/ImageToBitmap'
import Image00 from './platform/api/media/image/Image0'
import DownloadURL from './platform/api/media/download/DownloadURL'
import DownloadText from './platform/api/media/download/DownloadText'
import Start0 from './platform/api/media/audio/Start'
import OscillatorNode from './platform/api/media/audio/OscillatorNode'
import MixerNode from './platform/api/media/audio/MixerNode'
import MediaStreamDestinationNode from './platform/api/media/audio/MediaStreamDestinationNode'
import MediaStreamAudioSourceNode from './platform/api/media/audio/MediaStreamAudioSourceNode'
import GetByteTimeDomainData from './platform/api/media/audio/GetByteTimeDomainData'
import GetByteFrequencyDomainData from './platform/api/media/audio/GetByteFrequencyDomainData'
import GainNode from './platform/api/media/audio/GainNode'
import DelayNode from './platform/api/media/audio/DelayNode'
import DecodeAudioData from './platform/api/media/audio/DecodeAudioData'
import BufferSourceNode from './platform/api/media/audio/BufferSourceNode'
import AudioTarget from './platform/api/media/audio/AudioTarget'
import AudioSource from './platform/api/media/audio/AudioSource'
import AudioDestinationNode from './platform/api/media/audio/AudioDestinationNode'
import AudioContext from './platform/api/media/audio/AudioContext'
import AnalyserNode from './platform/api/media/audio/AnalyserNode'
import RequestPictureInPicture from './platform/api/media/RequestPictureInPicture'
import Play from './platform/api/media/Play'
import Pause from './platform/api/media/Pause'
import MediaRecorder from './platform/api/media/MediaRecorder'
import ImageCapture from './platform/api/media/ImageCapture'
import GrabFrame from './platform/api/media/GrabFrame'
import GetVideoTracks from './platform/api/media/GetVideoTracks'
import GetUserMedia from './platform/api/media/GetUserMedia'
import GetDisplayMedia from './platform/api/media/GetDisplayMedia'
import EnumerateDevices from './platform/api/media/EnumerateDevices'
import DocumentPictureInPicture from './platform/api/media/DocumentPictureInPicture'
import CaptureStream from './platform/api/media/CaptureStream'
import Location from './platform/api/location/Location'
import Upgrade from './platform/api/http/Upgrade'
import Respond from './platform/api/http/Respond'
import Listen from './platform/api/http/Listen'
import Intercept from './platform/api/http/Intercept'
import Handle from './platform/api/http/Handle'
import CreateServer from './platform/api/http/CreateServer'
import CurrentPosition from './platform/api/geolocation/CurrentPosition'
import Gamepad from './platform/api/gamepad/Gamepad'
import ReadAsText from './platform/api/file/ReadAsText'
import ReadAsDataUrl from './platform/api/file/ReadAsDataUrl'
import ReadAsArrayBuffer from './platform/api/file/ReadAsArrayBuffer'
import FileReader from './platform/api/file/FileReader'
import StopPropagation0 from './platform/api/event/StopPropagation'
import PreventDefault from './platform/api/event/PreventDefault'
import Listener from './platform/api/event/Listener'
import Listen0 from './platform/api/event/Listen'
import Dispatch from './platform/api/event/Dispatch'
import Verify from './platform/api/crypto/Verify'
import Sign from './platform/api/crypto/Sign'
import RsaAlgorithm from './platform/api/crypto/RsaAlgorithm'
import ImportKey from './platform/api/crypto/ImportKey'
import ImportJwtKey from './platform/api/crypto/ImportJwtKey'
import GenerateKeyPair from './platform/api/crypto/GenerateKeyPair'
import GenerateKey from './platform/api/crypto/GenerateKey'
import ExportKey from './platform/api/crypto/ExportKey'
import ExportJwtKey from './platform/api/crypto/ExportJwtKey'
import Encrypt from './platform/api/crypto/Encrypt'
import Decrypt from './platform/api/crypto/Decrypt'
import Log from './platform/api/console/Log'
import SetSelectionRange from './platform/api/component/SetSelectionRange'
import RemoveChild from './platform/api/component/RemoveChild'
import Register from './platform/api/component/Register'
import OuterHTML from './platform/api/component/OuterHTML'
import Lookup from './platform/api/component/Lookup'
import InsertChildAt from './platform/api/component/InsertChildAt'
import HasChild from './platform/api/component/HasChild'
import GetSelection from './platform/api/component/GetSelection'
import GetClientBoundingRect from './platform/api/component/GetClientBoundingRect'
import Detach from './platform/api/component/Detach'
import AppendChildren from './platform/api/component/AppendChildren'
import AppendChild from './platform/api/component/AppendChild'
import VideoEncoder from './platform/api/codec/VideoEncoder'
import CopyToClipboard from './platform/api/clipboard/CopyToClipboard'
import toDataUrl from './platform/api/canvas/toDataUrl'
import Translate from './platform/api/canvas/Translate'
import TransferFromImageBitmap from './platform/api/canvas/TransferFromImageBitmap'
import ToBlob0 from './platform/api/canvas/ToBlob'
import StrokeStyle from './platform/api/canvas/StrokeStyle'
import StrokePath from './platform/api/canvas/StrokePath'
import Stroke from './platform/api/canvas/Stroke'
import Scale0 from './platform/api/canvas/Scale0'
import Scale from './platform/api/canvas/Scale'
import Rotate from './platform/api/canvas/Rotate'
import PutImageData from './platform/api/canvas/PutImageData'
import MoveTo from './platform/api/canvas/MoveTo'
import LineWidth from './platform/api/canvas/LineWidth'
import ImageData from './platform/api/canvas/ImageData'
import GetImageData from './platform/api/canvas/GetImageData'
import FillStyle from './platform/api/canvas/FillStyle'
import FillPath from './platform/api/canvas/FillPath'
import Fill from './platform/api/canvas/Fill'
import DrawImage from './platform/api/canvas/DrawImage'
import Draw from './platform/api/canvas/Draw'
import ClosePath from './platform/api/canvas/ClosePath'
import Clear from './platform/api/canvas/Clear'
import BeginPath from './platform/api/canvas/BeginPath'
import AddRect from './platform/api/canvas/AddRect'
import AddLineTo from './platform/api/canvas/AddLineTo'
import AddArc from './platform/api/canvas/AddArc'
import WriteValue from './platform/api/bluetooth/method/WriteValue'
import ReadValue from './platform/api/bluetooth/method/ReadValue'
import BluetoothService from './platform/api/bluetooth/BluetoothService'
import BluetoothServer from './platform/api/bluetooth/BluetoothServer'
import BluetoothDevice from './platform/api/bluetooth/BluetoothDevice'
import BluetoothCharacteristic from './platform/api/bluetooth/BluetoothCharacteristic'
import blob from './platform/api/blob'
import Encode1 from './platform/api/base64/Encode'
import Decode0 from './platform/api/base64/Decode'
import Set2 from './platform/api/array/typed/method/Set'
import Uint8ClampedArray1 from './platform/api/array/typed/Uint8ClampedArray1'
import Uint8ClampedArray0 from './platform/api/array/typed/Uint8ClampedArray0'
import Uint8ClampedArray from './platform/api/array/typed/Uint8ClampedArray'
import Uint8Array1 from './platform/api/array/typed/Uint8Array1'
import Uint8Array0 from './platform/api/array/typed/Uint8Array0'
import Uint8Array from './platform/api/array/typed/Uint8Array'
import Buffer from './platform/api/array/typed/Buffer'
import RequestAnimationFrame from './platform/api/animation/RequestAnimationFrame'
import Animate0 from './platform/api/animation/Animate'
import Prompt from './platform/api/alert/Prompt'
import Alert from './platform/api/alert/Alert'
import ParseURL from './platform/api/URL/ParseURL'
import EncodeURIComponent from './platform/api/URI/EncodeURIComponent'
import EncodeURI from './platform/api/URI/EncodeURI'
import CreateObjectURL from './platform/api/URI/CreateObjectURL'
import Send from './platform/api/Send'
import ReplaceState from './platform/api/History/ReplaceState'
import PushState from './platform/api/History/PushState'
import State from './platform/State'
import OffscreenCanvas from './platform/OffscreenCanvas'
import FormData from './platform/FormData'
import UnsetPin from './f/unit/class/UnsetPin'
import SetInputConstant from './f/unit/class/SetInputConstant'
import SetInput from './f/unit/class/SetInput'
import HasInput from './f/unit/class/HasInput'
import Reset from './f/unit/Reset'
import Play0 from './f/unit/Play'
import Paused from './f/unit/Paused'
import Pause0 from './f/unit/Pause'
import HasPin from './f/unit/HasPin'
import Debug from './f/unit/Debug'
import Timer from './f/time/Timer'
import Interval from './f/time/Interval'
import Trim from './f/string/Trim'
import ToUpperCase from './f/string/ToUpperCase'
import ToLowerCase from './f/string/ToLowerCase'
import Test from './f/string/Test'
import Substr from './f/string/Substr'
import StartsWith from './f/string/StartsWith'
import Split from './f/string/Split'
import Slice from './f/string/Slice'
import Replace from './f/string/Replace'
import MatchAll from './f/string/MatchAll'
import Match from './f/string/Match'
import LocaleCompare from './f/string/LocaleCompare'
import Length from './f/string/Length'
import Includes from './f/string/Includes'
import FromCharCode from './f/string/FromCharCode'
import EndsWith from './f/string/EndsWith'
import Concat from './f/string/Concat'
import CodePointAt from './f/string/CodePointAt'
import CharAt from './f/string/CharAt'
import Behead from './f/string/Behead'
import Stringify from './f/querystring/Stringify'
import ParseQuery from './f/querystring/ParseQuery'
import Values from './f/object/Values'
import Set3 from './f/object/Set'
import Merge from './f/object/Merge'
import Keys0 from './f/object/Keys'
import HasKey0 from './f/object/HasKey'
import Get from './f/object/Get'
import FromEntries from './f/object/FromEntries'
import Entries from './f/object/Entries'
import Delete0 from './f/object/Delete'
import DeepSet0 from './f/object/DeepSet'
import DeepMerge from './f/object/DeepMerge'
import DeepHasKey0 from './f/object/DeepHasKey'
import DeepGet1 from './f/object/DeepGet'
import DeepDelete0 from './f/object/DeepDelete'
import ToFixed from './f/number/ToFixed'
import StringToInt from './f/number/StringToInt'
import StringToFloat from './f/number/StringToFloat'
import NumberToString from './f/number/NumberToString'
import Unit from './f/meta/Unit'
import This from './f/meta/This'
import System from './f/meta/System'
import Specs from './f/meta/Specs'
import Spec0 from './f/meta/Spec0'
import Spec from './f/meta/Spec'
import Spark from './f/meta/Spark'
import Scope from './f/meta/Scope'
import RemoteShareGraph from './f/meta/RemoteShareGraph'
import RemoteGraph from './f/meta/RemoteGraph'
import New0 from './f/meta/New'
import Inspect from './f/meta/Inspect'
import IdToClass from './f/meta/IdToClass'
import Graph0 from './f/meta/Graph0'
import Graph from './f/meta/Graph'
import Global from './f/meta/Global'
import Exec from './f/meta/Exec'
import Env from './f/meta/Env'
import Destroy from './f/meta/Destroy'
import ClassToUnitBundle from './f/meta/ClassToUnitBundle'
import Catch from './f/meta/Catch'
import Bundle1 from './f/meta/Bundle1'
import Bundle0 from './f/meta/Bundle0'
import Bundle from './f/meta/Bundle'
import Tan from './f/math/Tan'
import Sin from './f/math/Sin'
import Sign0 from './f/math/Sign'
import SQRT from './f/math/SQRT'
import Random from './f/math/Random'
import Pow from './f/math/Pow'
import PI from './f/math/PI'
import Min from './f/math/Min'
import Max from './f/math/Max'
import Log0 from './f/math/Log'
import Floor from './f/math/Floor'
import Cos from './f/math/Cos'
import Ceil from './f/math/Ceil'
import Atan2 from './f/math/Atan2'
import Asinh from './f/math/Asinh'
import Asin from './f/math/Asin'
import Acosh from './f/math/Acosh'
import Acos from './f/math/Acos'
import Abs from './f/math/Abs'
import Or from './f/logic/Or'
import Not from './f/logic/Not'
import And from './f/logic/And'
import UUID from './f/id/UUID'
import SetUnitPinData from './f/graph/class/SetUnitPinData'
import SetUnitPinConstant from './f/graph/class/SetUnitPinConstant'
import SetName from './f/graph/class/SetName'
import SetMetadata from './f/graph/class/SetMetadata'
import AddUnitSpec from './f/graph/class/AddUnitSpec'
import AddUnit0 from './f/graph/class/AddUnit0'
import AddPin from './f/graph/class/AddPin'
import AddMerge from './f/graph/class/AddMerge'
import Unplug from './f/graph/Unplug'
import SetUnitPinData0 from './f/graph/SetUnitPinData'
import SetUnitPinConstant0 from './f/graph/SetUnitPinConstant'
import RemoveUnit from './f/graph/RemoveUnit'
import RemovePlug from './f/graph/RemovePlug'
import RemovePin from './f/graph/RemovePin'
import Plug from './f/graph/Plug'
import Edit from './f/graph/Edit'
import BulkEdit from './f/graph/BulkEdit'
import AddUnit from './f/graph/AddUnit'
import AddPlug from './f/graph/AddPlug'
import AddPinToMerge from './f/graph/AddPinToMerge'
import AddPin0 from './f/graph/AddPin'
import AddMerge0 from './f/graph/AddMerge'
import SetHours from './f/date/method/SetHours'
import SetDate from './f/date/method/SetDate'
import GetTime from './f/date/method/GetTime'
import GetDate from './f/date/method/GetDate'
import Now from './f/date/Now'
import Date from './f/date/Date'
import TypeOf from './f/data/TypeOf'
import Stringify0 from './f/data/Stringify'
import Evaluate from './f/data/Evaluate'
import Wait from './f/control/Wait'
import Void from './f/control/Void'
import Throw from './f/control/Throw'
import Push from './f/control/Push'
import Plan from './f/control/Plan'
import Next from './f/control/Next'
import Memory from './f/control/Memory'
import Loop from './f/control/Loop'
import Iterate from './f/control/Iterate'
import If from './f/control/If'
import Identity from './f/control/Identity'
import Default from './f/control/Default'
import Constant from './f/control/Constant'
import NotEqual from './f/comparison/NotEqual'
import LessThanEqual from './f/comparison/LessThanEqual'
import LessThan from './f/comparison/LessThan'
import GreaterThanEqual from './f/comparison/GreaterThanEqual'
import GreaterThan from './f/comparison/GreaterThan'
import Equals from './f/comparison/Equals'
import XOr from './f/bitwise/XOr'
import Or0 from './f/bitwise/Or'
import Not0 from './f/bitwise/Not'
import And0 from './f/bitwise/And'
import Sort from './f/array/Sort'
import Slice0 from './f/array/Slice'
import Remove from './f/array/Remove'
import Put from './f/array/Put'
import Prepend from './f/array/Prepend'
import Pop0 from './f/array/Pop'
import Length1 from './f/array/Length'
import Join from './f/array/Join'
import Insert from './f/array/Insert'
import Init from './f/array/Init'
import IndexOf0 from './f/array/IndexOf'
import Fill0 from './f/array/Fill'
import Concat0 from './f/array/Concat'
import At from './f/array/At'
import Append1 from './f/array/Append'
import Subtract from './f/arithmetic/Subtract'
import Remainder from './f/arithmetic/Remainder'
import Multiply from './f/arithmetic/Multiply'
import Divide from './f/arithmetic/Divide'
import Add from './f/arithmetic/Add'
import Stringify00 from './f/JSON/Stringify0'
import Stringify1 from './f/JSON/Stringify'
import ParseJSON from './f/JSON/ParseJSON'
import Format from './f/JSON/Format'

export default {
	'fd4f28bb-9114-46b4-92d2-5dfcaaf7d65b': Pin,
	'0c6703a1-e949-4b55-9e84-71e6c9addd64': Worker,
	'98ab5ee1-0997-4ad2-bc77-776208b6bb25': Write,
	'752a3a19-bb1e-4e6d-b363-cfa98e8864be': Read0,
	'c6da6b9f-a783-4e58-a252-e543aef109fb': Read,
	'7fe5b907-e9d3-4427-96cf-1b3be39a9bba': Start,
	'324b9c5e-5810-11eb-bf7c-634b3bb07f8c': New,
	'23acb820-8820-4c4f-8e28-ee4daa4cc056': FromUnitBundle,
	'de2d42e2-4fca-4a3f-8783-3585c546e88b': FromBundle,
	'bddaba6f-83c8-4d25-97e2-ef1cdecd19e4': Boot,
	'eaf5e67b-6c48-4a27-85e1-9d5a8aa72e24': Subscribe,
	'610b35bc-a709-4eed-a655-9ee0baa860f8': Set0,
	'074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c': Set,
	'e4fb7815-95e1-4cbc-b2e2-750605e30258': Keys,
	'b409ff98-1c9e-4990-b2c2-d7f32fda50eb': HasKey,
	'936820bc-9e27-4aad-b96b-cb19250e4ad3': Get1,
	'bc0320e2-2eb8-11eb-a38f-a779bfe81645': Get0,
	'275af55d-9fcf-4b53-9087-d97455cbe528': Delete,
	'64f8e8bc-124d-49f6-a143-625265eafe68': DeepSet,
	'dfb2c4fb-2536-4cd1-bece-1c1bd3796c3f': DeepHasKey,
	'f0779efd-237f-476d-bddc-205d7c28cfb5': DeepGet0,
	'8e6a00bf-2fb7-4252-adb4-7ffedde69b47': DeepGet,
	'ae6e44d8-2c41-496a-ad98-035468622cfa': DeepDelete,
	'f615f030-15dc-44be-9889-c4a68092d400': Append,
	'd0f94e4e-43f4-4c0a-b07e-ca40c82f48f4': StopPropagation,
	'12d1e7be-a5a6-45ba-82d7-cce3d03b96e2': Focus,
	'0f49972c-fcbc-424a-90e5-d4c02ae07409': Click,
	'b51db03f-4d2d-44f9-bbd9-116aa0b086d0': Blur,
	'05b6f707-a009-40aa-aacb-a15888c2a8b3': AttachText,
	'05169310-5447-4cf8-a90f-fda957de4891': AttachDropTarget,
	'4730fbc1-dd24-4b6a-adc2-d71e2b2df22d': Shift,
	'04e8b64e-7fed-49a0-af48-eba025be3fbc': Put0,
	'dff853f8-7bb4-48dc-a792-5efdead94640': Pop,
	'ec482aaf-0029-4b85-b03a-de5bd361d706': Length0,
	'26b06e21-798c-4bc4-96e1-12a4351c083d': IndexOf,
	'1625eaa0-a56c-4d35-919b-bc68ed626815': At1,
	'c320b1b2-c130-4d69-b172-0c737b72c6b5': At0,
	'cf4db91a-f8b2-454f-a763-12005d71cb9d': Append0,
	'355b5332-0cc9-4a5c-989e-043d717215ec': ParentChild,
	'd4945010-686d-431b-a884-1a4db0bfafc4': Children,
	'59afce80-30e7-4322-84e6-955767bb5106': Child,
	'6a14988f-5f4b-4fab-af32-226b7844e41f': TextField,
	'83ec6688-b80b-4ef2-861f-14245ef392c0': TextArea,
	'87f99b85-1c24-4e5b-a903-dd27230f4092': Text,
	'e06518cf-9edf-430b-8751-74c486e407aa': Slider,
	'6c7cd7d1-c8a0-4317-9c8c-ba781f150729': Select,
	'0f82f52f-0380-46d5-a959-0eebd5de503e': RadioField,
	'51c2c7b4-cb8a-42e8-95ab-14b8ac37700c': PasswordField,
	'c0d13c03-9b10-4a6f-a79f-66294d10aae6': Option,
	'9bc56564-ef4e-11ea-939a-27ae3feb321e': NumberField,
	'e2109627-9783-4664-a70c-858fd8c46ea5': FileField,
	'429496bf-98fa-45e8-81b8-960f4e2546ba': Fieldset,
	'6309ac3f-4a37-4ab0-86c6-8be70b38e31d': EditableField,
	'd8aa573f-129e-4587-9c64-674729d024e2': Color,
	'096fc4ca-edd2-11ea-8266-37b634a3ee0b': Checkbox,
	'4e555154-695c-471a-8a91-47bda70f8110': View,
	'ad12678e-6642-11eb-9fc3-9fbc75c58110': Use,
	'00c828fc-9243-11ea-b897-5b0fc55820c5': TextPath,
	'49ef122e-b4d1-11ea-b45e-b73d8ee2aae8': Text0,
	'e535bcf4-395f-41c7-afa4-01a4861c8859': TSpan,
	'3c629fa2-6cc6-4ebc-b265-80444b446d2b': Symbol,
	'c68b0424-ced2-43b3-ac82-965163579f7e': Switch,
	'56744e26-6909-4432-9849-2c77b0f2f2bf': Stop,
	'224dcb68-db0e-494c-8b91-7e2ebe0051c6': Set1,
	'98c279fc-7f5e-11ea-b9e4-f772f9f0bed1': SVG,
	'c0bfe832-8967-11ea-8c4c-1f2995e41b68': Rect,
	'd1c76124-8869-4145-ba30-e3604e928527': RadialGradient,
	'4a06405b-29d6-483e-9ab4-5f659e139e4c': Polyline,
	'e4f85559-b661-49a6-aa90-9191c00e59cd': Polygon,
	'de8e7f1a-3064-4e04-b47e-eb06386ac794': Pattern,
	'60bc7930-8982-11ea-8b24-cf97a783bb32': Path,
	'a9d998f8-4e62-40b0-8c4d-440e39d28ca3': Mask,
	'9932f3bc-9241-11ea-89fa-0b2fdace0f08': Marker,
	'a95746c4-013d-4dd4-8488-fdca75c4757b': MPath,
	'a693fa9e-1ab3-4145-968a-9c234a7df038': LinearGradient,
	'38d26d76-2559-11eb-ae02-dfda9b9b137e': Line,
	'3865cbaf-aac1-4640-b809-c08f979b67f0': Image,
	'be11165e-489f-11eb-921f-87b924eb0725': Group,
	'e049f16e-2559-11eb-bdc4-db5b8a11164b': ForeignObject,
	'be0975fc-a9c7-4d92-a3b9-4479e986c2af': FilterEffectTurbulence,
	'bdce9206-5331-47dd-a111-902ee41f16ce': FilterEffectTile,
	'01193871-ae03-4ab3-9d06-e9956b28e626': FilterEffectSpotLight,
	'e98c55d5-9dce-4ca3-b7e5-08aa6b18eacf': FilterEffectSpecularLighting,
	'1fca03b4-707c-4f16-aeb5-992e55f351c6': FilterEffectPointLight,
	'9023fbd3-8308-4436-a26a-cc19044183e4': FilterEffectOffset,
	'541f7ae5-3db1-4344-8e87-f42e4d1fdfe8': FilterEffectMorphology,
	'1a362a13-9df1-4b22-a9b5-91cdeac1e00f': FilterEffectMergeNode,
	'f87fd33f-c02a-4238-959f-3520611c7903': FilterEffectMerge,
	'bc9e9f08-877a-4814-a33f-ee80c013fca3': FilterEffectImage,
	'8fa07772-cd92-4b7b-b876-29883a27d7c7': FilterEffectGaussianBlur,
	'd94b1e9d-0445-4e54-a549-b79e47a3c7a0': FilterEffectFlood,
	'0c15cd43-6997-4f9f-b52f-acd4c0ed0670': FilterEffectDropShadow,
	'fc78d9fd-45dc-4b01-83d9-8979b5697f56': FilterEffectDistantLight,
	'1e9b1142-bbcf-4627-8cc2-86d5a3bb3dd1': FilterEffectDisplacementMap,
	'fdae0046-d36c-4b21-bb1d-77182d89cadf': FilterEffectDiffuseLighting,
	'7db232f5-870c-418a-8efd-fa9bba6c8c4a': FilterEffectConvolveMatrix,
	'90d0f768-3991-4cd3-9995-07d0dab6d41c': FilterEffectComponentTransfer,
	'6a9360da-a323-4e67-b522-4dbd704483a3': FilterEffectColorMatrix,
	'066655a1-b9ac-4877-a258-53c8a008db0e': FilterEffectBlend,
	'7bc94934-0b91-46ca-bf45-7b5d2918dd6a': Filter,
	'b173c896-4818-46a1-9a5b-ef3a90fea45a': Ellipse,
	'3fcb8e64-923d-11ea-bab1-43fa3b273af8': Defs,
	'8a204a3a-12af-4970-8851-464ebb91342e': ClipPath,
	'7666978e-252c-11eb-97a4-0f3e81286cae': Circle,
	'25f45f9e-1a62-4b96-9347-7ea5bc0af651': AnimateTransform,
	'9140df42-1c5e-4e18-a106-6ad9be30bb55': AnimateMotion,
	'4e97caab-d48d-488e-b56b-4141e68fed85': Animate,
	'7a8921eb-c1ad-400b-94fc-6c6cead8163d': Video,
	'059579bb-184f-435b-ace0-64ec95c9f125': Image0,
	'06823924-b659-4a22-8ed4-b3243121b55d': Audio,
	'94243ec4-8967-4907-8cdd-7223fe256cf6': Canvas,
	'e39a2a34-c71a-11ea-9835-07964acf6760': Transcend,
	'4caaa14d-282f-49a0-832e-c5254735efbf': Search,
	'6b18c608-7b5a-11ea-bb6e-2ff12a5cc3f3': Resize,
	'bc34c618-1c77-11eb-9785-e39a2bf52e49': PhoneKeyboardKey,
	'fcccb9a4-1a30-11eb-93b0-e7d511d031f2': PhoneKeyboard,
	'96d5d60e-85eb-11eb-ba90-7fc42ab0a641': GUIControlKeyboard,
	'c9b62bcc-8196-11eb-8372-9f2ac2c356d4': GUIControl,
	'0f043df2-46fc-11eb-ae20-6f1fedd527ba': GUI,
	'e80c912e-7508-11ea-966b-436805345ff0': Editor,
	'4df9733c-9e3a-4ec2-9473-54ae2172cbe6': Editor0,
	'ccf6d0e2-6b08-11eb-9fc3-3785374109d0': Editor1,
	'cbf8f925-05df-4562-81ed-8cc1ddac6aac': Editor2,
	'b61f5cc6-37e9-45e1-965b-02940820f7ce': Editor3,
	'0ea7279e-9ca2-48ab-8d70-f5333a717dc4': Editor4,
	'66698a97-15c5-4602-9925-11a1aeb03710': Editor5,
	'f59a94c6-4d05-496a-bb36-da5263703ea1': Editor6,
	'dd7616e2-2e64-4d9c-b13e-ca7efeacd982': Editor7,
	'321f971c-b898-4ca4-9e6e-3d75d68940f7': Editor8,
	'b7f043ee-4f9d-4f69-90fe-63b1357ff4c2': Editor9,
	'23b7df22-79e0-4233-8388-7e6e8f1859c6': Editor10,
	'2a5ad480-9d38-4918-8774-41fac7b54203': Editor11,
	'c711d540-9de3-437e-854a-b59491af3cf8': Editor12,
	'58bfcb06-b41d-4205-91f5-c00aff3e209c': Editor13,
	'2168add9-f2f9-4a9d-9af3-5da57705c4f9': Editor14,
	'eff80fbe-2f83-4a59-8576-9ec0c79ce439': Editor15,
	'9487c48c-ab31-45ae-897f-348ec222b35e': Editor16,
	'e7d8b387-3ea7-490e-80da-40af51c9ac4a': Editor17,
	'fecc2df2-ce36-4401-8eed-63d65fb67e6d': Editor18,
	'e8bce1fc-ae56-4f9f-9685-3cc844758855': Datum,
	'c18d7dcc-939b-11ea-90cb-77846d7504a9': Class,
	'0e9e6cd4-67eb-11ea-995b-4b0721193361': Bot,
	'3ffeaaf8-30dd-11eb-9dcc-836b075fc64d': Zoom,
	'454aaff2-cd74-4f6e-baf2-631bb32e7a6b': Wrap,
	'3ea02a11-9b11-46d9-948e-ff0e21e4ba14': Section,
	'7772a2f5-40c8-482e-83f4-bed9bfb364e3': Render,
	'78b0939d-43e1-4f6c-867d-e4217a55d217': Parent,
	'ded3f778-b5f2-4f1f-80cd-7cf8ba18165c': Nav,
	'b5286262-9f92-40d3-8545-88fb3079a0f9': Inherit,
	'63a417e5-d354-4b39-9ebd-05f55e70de7b': Icon,
	'd7c86a2a-489f-11eb-b83e-d3767f6d49b7': Frame,
	'5628f1fb-8c36-4844-b459-89611c07c359': Footer,
	'b7bbde81-0ad8-4719-b1a2-cbaf48bb94a4': Article,
	'72c84615-4d9c-4a82-a828-fa5d9447a4d5': Icons,
	'81a54674-4e9c-11eb-a0e4-2b75980dbd9b': WakeLock,
	'68992d62-d5ca-11ea-888d-97179b32b7ab': vibrate,
	'56125930-6819-4c03-87c6-3fa042824715': Encode0,
	'12de8298-28f6-4b2b-8962-51cb41e5f99b': Encode,
	'24b50c35-e558-4911-a3e3-8ee37777b1f5': Decode,
	'ffc86129-e199-4ffb-bea0-f7307e62eafc': TextEncoder,
	'a64f3008-ad0d-401b-8294-cf222a5a4ca7': TextDecoder,
	'dc513ed0-09f4-11eb-a54a-7f4d4e253ef5': SessionStorage,
	'c8f3faa8-09f4-11eb-a3b1-477aa3ec4193': LocalStorage,
	'32c6b01a-06af-4145-b02e-1b0276e05379': LocalObject,
	'6db29a62-2035-4cfc-a9d3-03444a8bc2b8': TextToSpeech,
	'416550cc-6e02-4ff2-aafa-2f0edbf121c6': SpeechToText,
	'04eda925-4423-40c8-83c8-2117a0d81185': Share,
	'de9665db-a188-4252-99f0-ea50fc343058': ScrollIntoView,
	'9d51399e-06a0-44c6-9e98-04041159b9f3': Scroll,
	'adcd6571-0884-45e8-ac58-8c73f307d98e': BroadcastChannel,
	'c7183c96-74cb-4ded-a816-e74d986e7ea8': TogglePopover,
	'eed20c86-41fe-46d4-87ba-ad2e6fb1bd4a': ShowPopover,
	'c6f309c8-9ca7-459c-9dd5-c9c9f92fbe8f': HidePopover,
	'd3fc887c-9fc5-11eb-8f63-ab42b0414469': SetPointerCapture,
	'7375aad5-50fd-403c-80ae-471b95088f04': PeerTransmitter,
	'f079a38e-fb4f-496e-8e5f-d5e03a590cda': PeerReceiver,
	'efd75c06-67c3-4053-8dda-9aadc1d0161c': Tags,
	'cdbac889-fb2d-4975-8938-00641a61f35b': DomToUnit,
	'2f2d5ea4-6dd2-406e-a095-5552ebc235e7': SizeObserver,
	'b27ee28f-54fb-4737-91f5-04b52b7cf92d': PositionObserver,
	'e8aded15-a1af-42a0-9a9d-f88fcfd03dc3': Observe,
	'34a36b3a-cb04-4429-bdbc-15e0c278ad7a': IntersectionObserver,
	'5aea0bf0-0815-11eb-9304-5f90b5542620': Show,
	'bb029770-080e-11eb-9d38-f314d076f14b': Notification,
	'29e974cc-081b-11eb-a607-1fd4ec67a52f': Close,
	'81e15593-293c-4890-ae8e-d1e845673d28': ReadableStream,
	'b8fc168e-ee2f-11ea-a42a-730934861ff1': WebSocket,
	'b0d71197-fad7-4fc6-87e4-97636d365de6': ToText,
	'4e14b9e8-a694-4c58-b509-fc53a279c22c': ToJson,
	'e22782a9-31e9-4b12-83ca-1000607fd39b': ToBlob,
	'e0cc1342-810e-4d19-a450-08498819fae7': ToArrayBuffer,
	'b97c0133-6c87-4b69-af4e-354c0b590ece': Fetch,
	'41de8d5e-2c41-441c-ad29-cc3f5d4e6c7a': EventSource,
	'262beb5f-21bd-4848-a62d-185f6f8a78e1': ImageToBitmap,
	'11822d85-9e53-4658-92ed-f0c0428a5565': Image00,
	'c18c8f59-f3c8-49a8-9dbd-ed30fdf856e9': DownloadURL,
	'b5ab65ce-4306-4a46-8d3c-36b6c29b1c60': DownloadText,
	'766e8fb5-b78e-4266-8571-54238eb1636b': Start0,
	'c2738ec3-72fa-4432-96b9-74abb1a6f26a': OscillatorNode,
	'33c623e5-bce2-4f30-9a98-50218bb6c431': MixerNode,
	'009976af-80f1-4144-9be4-4b8126586354': MediaStreamDestinationNode,
	'31408be3-cc2a-490a-b0d1-96e0028ca68e': MediaStreamAudioSourceNode,
	'e4ea5dce-10ea-434b-a93d-c874a92f2f39': GetByteTimeDomainData,
	'2ec96f8b-4ea5-4ba8-ab8d-a00105c6cb71': GetByteFrequencyDomainData,
	'a8d7c089-0385-4922-bb3a-6c550a8a1b3b': GainNode,
	'9543c94b-e19e-430b-8a48-9cda8dae44c5': DelayNode,
	'59332eaf-ab47-44e5-9417-7179574fb2af': DecodeAudioData,
	'9007bcd5-6697-480c-9566-a5edf4d7c90f': BufferSourceNode,
	'a7dee8c6-15a3-4b7e-8f63-03f13a7d34a9': AudioTarget,
	'5c13db99-0923-4b27-85e3-7a18dbfdd309': AudioSource,
	'71ff4fda-5878-4d4c-b55b-c2c79d8dc546': AudioDestinationNode,
	'f5df301d-da63-492a-9e59-950289fe6ba9': AudioContext,
	'210632fc-f85b-4f13-a2a9-f689ff85da78': AnalyserNode,
	'3889d2f1-a0ed-4e8c-8e75-7a6683224275': RequestPictureInPicture,
	'ab507863-2307-40c6-982b-c45680458997': Play,
	'44968bd5-f1a5-4f81-a32f-8ee5a6e4a842': Pause,
	'7e1b3a4c-be6b-11eb-b098-1b6b9db93f1e': MediaRecorder,
	'a57383a9-5b24-4dbb-a5d1-0e278d036f89': ImageCapture,
	'f238caff-3f71-40d9-b1a9-d992060fea04': GrabFrame,
	'0bc0c4ad-d2e0-4e3e-92e8-5b9dfee1cf5e': GetVideoTracks,
	'a6e30b43-9ab4-4206-bfba-3f2129faac30': GetUserMedia,
	'6705462c-5b47-11eb-9dfc-2f14c58b2789': GetDisplayMedia,
	'3511f756-2a02-4346-b417-8c34502f79d4': EnumerateDevices,
	'ba8b9b28-79f5-42d6-9c98-3555ce4982cb': DocumentPictureInPicture,
	'30e125ba-af81-11ea-ba6b-e70218ca7afe': CaptureStream,
	'30f6738c-1938-4dcd-9e7f-6c10f9730021': Location,
	'8a7e3307-7e3b-4360-a59e-6e95c507ebf5': Upgrade,
	'7ef1c827-bbd4-4339-94c5-9fce05e50667': Respond,
	'7e5710aa-faf0-41c4-8936-2583ac637c72': Listen,
	'6dbf7f62-cd6c-46a8-a559-ca50aebab9c4': Intercept,
	'a9aaed9e-a0ca-423f-bb44-4ee0b3432471': Handle,
	'd52ecdec-776b-425c-b982-ce25ee8113bd': CreateServer,
	'a9cba5ec-940d-42a3-b861-86197402cbe4': CurrentPosition,
	'77238fd9-a968-454d-b7ce-0277bc37475d': Gamepad,
	'e025d8e5-baa2-4411-864d-4db6fc42220f': ReadAsText,
	'27ed8152-aaa0-4ac7-bebc-8b582727b129': ReadAsDataUrl,
	'bf92df60-f487-430f-a3e8-c988d57eadbb': ReadAsArrayBuffer,
	'f8485868-345a-416a-b323-547ddcb068ad': FileReader,
	'48db8d23-dc55-4b03-b2ff-ca56c61927c8': StopPropagation0,
	'8127337f-955d-4365-b180-21de8426feaa': PreventDefault,
	'aa810e5e-bf17-4abc-b726-bc06a7f210d9': Listener,
	'367241d8-ad12-11ea-beed-9777f31699a8': Listen0,
	'a1cd3c3c-b1fa-40a2-80d1-32f416264a3d': Dispatch,
	'65180989-78be-414a-88c7-bf58af08e0f5': Verify,
	'd3719453-ca94-4827-a6b6-5aa8f87b1dc5': Sign,
	'378b4049-860a-44a3-82f2-12a15499859c': RsaAlgorithm,
	'6fdcf0d8-39ce-4d63-ad68-97d25be769ab': ImportKey,
	'4830eec3-2a72-4e36-b68a-902aa73c6ead': ImportJwtKey,
	'089d3cef-2597-4777-8558-9942b4029472': GenerateKeyPair,
	'00e14b7e-7339-4c9f-a3ff-a16562558a28': GenerateKey,
	'd54cd5d2-91eb-4f95-be2d-62fdaf86f474': ExportKey,
	'6183465e-381f-4546-8c42-6b7eaaa25926': ExportJwtKey,
	'8edf4dd9-4d11-444c-bfe5-b54dc141cded': Encrypt,
	'f6400b55-10af-4983-96bc-6b915433f3b6': Decrypt,
	'e7232263-a2cf-4f2b-a862-4fc85933d09f': Log,
	'45654a47-f04e-484e-886e-99803aa48ab6': SetSelectionRange,
	'6dbff818-02b9-11eb-9ee7-93b57419f741': RemoveChild,
	'fb3fc7b4-3175-41ce-9546-cf3a07053cdc': Register,
	'b6a5a63f-07b2-4cbe-8718-377c245c502e': OuterHTML,
	'1ba931d8-0226-4600-9a48-dbb1b17d8d82': Lookup,
	'41a8c91e-87f8-4d96-9714-33716f329f7b': InsertChildAt,
	'c475117a-02b9-11eb-b7c8-579fe4f6c669': HasChild,
	'0d1d2204-f096-4aac-99d3-7c8dcdde8767': GetSelection,
	'd33eba3a-4a78-40b7-8501-77d74a8451ee': GetClientBoundingRect,
	'1ba97b81-5084-49b8-8fbf-227ccd31cabc': Detach,
	'2ea56c24-642b-420b-ae7d-e434299c7003': AppendChildren,
	'ee4715e6-f479-11ea-b231-bf95a7f38a99': AppendChild,
	'874f508f-d027-4e0b-852e-b4027e714406': VideoEncoder,
	'0b5a71c6-5c43-4e55-a29c-27d9ff7ed43a': CopyToClipboard,
	'002fbcc6-ec01-4282-b5a6-77ec4812744e': toDataUrl,
	'6f79ee03-4b3f-439c-b955-5529f3bebcc9': Translate,
	'b2eb49a8-7a7a-446a-ad36-e7c1efdaf61f': TransferFromImageBitmap,
	'c9d64ef4-35f6-44e7-a16b-1e4173f951dc': ToBlob0,
	'83d22558-2c6f-4dd4-a231-baba798d1d97': StrokeStyle,
	'c0e124ca-381a-414b-93a2-41526df02e28': StrokePath,
	'9a7c22e3-3de2-4c99-ac1f-b2f8ceffae99': Stroke,
	'af361c4c-0c46-4947-8692-1ddb308e5218': Scale0,
	'2e2bede5-41a9-4c35-8b02-482b610837ff': Scale,
	'8f7ce559-a046-45bc-8e98-c39934ed0ae6': Rotate,
	'138d16a7-a200-4329-9b4a-17abd24943d4': PutImageData,
	'3c47d4bc-315d-4600-a9cd-6e388b345980': MoveTo,
	'21e49492-49ba-4efd-879e-4cd7bb1bd587': LineWidth,
	'8e978642-b686-41fd-b2af-9a4c5db6bfa4': ImageData,
	'3ab81e83-5954-4bae-ad3e-ebf409dd23c4': GetImageData,
	'f5b2faf1-3a8b-489f-9d99-62d3c749ced6': FillStyle,
	'be59cf84-fcf2-46ef-aa34-6f0f8e055680': FillPath,
	'87a11e2c-278c-11eb-9209-2f30aebffb25': Fill,
	'82cf909e-a78f-4f3e-b87a-976458c8e15d': DrawImage,
	'53018958-b686-11ea-bf53-175a3698c92d': Draw,
	'288aede9-59ea-4cb4-baf9-fef9109cc2b9': ClosePath,
	'1ef77768-7394-4b83-ad11-f5905fa9d0d3': Clear,
	'81c0f469-ab88-4bc8-89d5-98d291b1d8b2': BeginPath,
	'58385055-7f06-472a-be9e-26bb5bce276a': AddRect,
	'2b0ef9e9-028b-4acc-9daf-6999e86cc2af': AddLineTo,
	'6796cd2d-2bd2-4dd3-9396-49d6bc1d2652': AddArc,
	'56eb0818-308a-4459-98c0-b05ffb219c05': WriteValue,
	'cdea4530-d391-4661-bf92-21450d2e825a': ReadValue,
	'a44b2198-e18d-11ea-be3b-77e13b78b7e3': BluetoothService,
	'dd520754-e138-11ea-879e-3bd947893124': BluetoothServer,
	'4ad5bd0e-e11e-11ea-ad4c-83da30628333': BluetoothDevice,
	'c7f6f43e-e8ed-11ea-92b2-0bd612272247': BluetoothCharacteristic,
	'89d07aa2-579f-4a4b-938c-0d85a24df56f': blob,
	'ee7b692f-5fe5-43c3-b636-aacca92b0bc7': Encode1,
	'd6f727ee-5158-4e2b-a2d4-a84ee712144e': Decode0,
	'0fdae01c-cf4c-49ee-8fee-23890625ae29': Set2,
	'98881480-aeba-4fee-b7d3-8c17a6aeb217': Uint8ClampedArray1,
	'4d68d552-46d6-4ee4-9823-63f9b9479fae': Uint8ClampedArray0,
	'cd8c1d94-1471-49e2-8b43-d98ae93b70f3': Uint8ClampedArray,
	'364fad98-9190-47a8-bd5c-33d7b882ddd6': Uint8Array1,
	'5500c4ae-e464-40fa-9cfb-6af11c8f2c7e': Uint8Array0,
	'c91ce066-ea5f-496d-8783-8f46c29673de': Uint8Array,
	'04d118fd-433e-4dd0-b828-0117eece566a': Buffer,
	'b949221c-8227-4178-bde4-5e8754a7ed39': RequestAnimationFrame,
	'1df77a6e-7632-44f0-9878-2aa5e0903928': Animate0,
	'fa3d97bb-060d-4671-9c18-dff81f64c1cc': Prompt,
	'0b4aa055-010d-4d43-b991-f38a95cdb380': Alert,
	'81ac8195-57ed-4b22-b8b8-fe3e68b11af0': ParseURL,
	'27e2f302-c23a-4447-abde-8309a94b331d': EncodeURIComponent,
	'5bd48844-67c6-4fdc-b23b-f03cd561877f': EncodeURI,
	'1d5b6bb0-f18e-4428-a350-a29d8ca3ff4a': CreateObjectURL,
	'b296242e-8b82-11eb-ac6c-0f8d3f9948d0': Send,
	'a3246170-d638-4d96-8900-6cc3f2ffe799': ReplaceState,
	'53dd6448-f1e8-46ed-b3e8-b03b846133bb': PushState,
	'c899b675-c3c4-428e-b548-b228305c0302': State,
	'8d7fc133-7cfa-4975-836f-31ae15b818be': OffscreenCanvas,
	'0966c9b3-2fd5-4b5b-8146-82fb08bd14c4': FormData,
	'33434271-3533-4a4e-adb9-306e35ab6afe': UnsetPin,
	'8bd5bfb5-979c-4e51-917b-75e150d9170f': SetInputConstant,
	'43b43afd-9e7d-44ba-aef7-6e9db4ed8744': SetInput,
	'ac5863fc-5156-4a27-a6ce-148dc93f34dd': HasInput,
	'd745a41b-70ae-4162-a1d8-aac17d73b73d': Reset,
	'ff84b8cd-216f-4bcf-8e29-e7c9998cae3d': Play0,
	'49517cda-b9da-4d80-b849-61fc2260317d': Paused,
	'a85fd9ad-5aec-4ebc-9008-e22db851dfa8': Pause0,
	'e599801e-d8c1-46a7-a2e9-4cae372b3606': HasPin,
	'c2184162-4fda-49fb-afc3-6bc882a2736d': Debug,
	'95076599-0f2f-46b6-a9e0-b4cbfdb8dcc9': Timer,
	'42a8023a-0581-4e92-968a-b31584d0ed75': Interval,
	'25cb84d7-ca96-4d79-926d-c01517a8d851': Trim,
	'd4e4d4b2-80e0-4066-8d6f-5051e9a11a10': ToUpperCase,
	'adde2d16-e1e6-4599-9a64-dd0968797041': ToLowerCase,
	'c2fec1e6-b370-4069-bb43-6dab5a78b9ab': Test,
	'141eaa06-bb12-42f1-a46f-32ceefb64ddc': Substr,
	'387fef8e-3e75-4deb-86a0-7b1120992589': StartsWith,
	'e1e106ad-e15d-4044-82f6-27ddd476d7c8': Split,
	'c8a4cd44-a554-4901-8a33-a8adbff63d03': Slice,
	'af5469c4-a09e-4b22-8133-a21e721e7639': Replace,
	'9da2b1ce-005e-4ec1-a73a-eee9850c97e2': MatchAll,
	'b16cccf7-fe33-43a6-b208-48db494376e8': Match,
	'065d2fc3-af3b-4704-b26e-228d71f61771': LocaleCompare,
	'1b8ce255-0bc7-4656-bafa-3dc86af44126': Length,
	'38bc7001-3543-48ba-99a5-96aeb908494b': Includes,
	'25d0e003-f002-45ae-a50c-6fa3bffee4eb': FromCharCode,
	'f2ac8a60-70bc-4743-934b-c5cae16b42c1': EndsWith,
	'779e538c-b0b9-477e-a986-30ee3abe6fe6': Concat,
	'998ae4f0-00ca-4c5f-9517-d47ed1d34457': CodePointAt,
	'eb345e08-08fd-4032-bd69-a4e9f55e7aa6': CharAt,
	'3e20a18c-60a3-40cd-bbee-f2f9e289b14d': Behead,
	'f97f2a74-d9a9-411d-afd3-fda46ba86c3b': Stringify,
	'02f91720-c4d5-4d66-ae91-d46ddc635722': ParseQuery,
	'964d3314-75fe-4a09-8ba8-c49145f29d49': Values,
	'c4784b05-1f50-44ad-b812-545b3ed77614': Set3,
	'60bdba6d-c670-430f-be72-6f39cf4e8453': Merge,
	'45b9c329-64e9-4c4a-800b-790947c75754': Keys0,
	'ad2ae8b9-9674-4b22-bed4-4458e0030b1a': HasKey0,
	'9414421d-3376-4438-aa03-7afcd860972c': Get,
	'ded32513-925d-4b37-924d-c85387c08ce9': FromEntries,
	'75ef6bb6-f7f1-4d48-a16d-2c04e05b14cf': Entries,
	'664b5d3c-e4cf-11ea-ab74-eb6d2f3bd6f1': Delete0,
	'419e468e-e4d4-11ea-8efb-2b9d815b1798': DeepSet0,
	'2af12780-698c-40ca-baa9-5f3260377e0f': DeepMerge,
	'740fde5d-8de1-448f-87d9-2ddd397e9c4b': DeepHasKey0,
	'2ff102a7-b469-461f-a3b1-a61b81c1b325': DeepGet1,
	'9c903a42-4bc2-4f6b-8937-5dc464f34574': DeepDelete0,
	'4a2fc8f5-17a8-4665-8895-eee4b242121e': ToFixed,
	'8cd29108-95cd-4217-9721-11f7c7c1131e': StringToInt,
	'f60adade-f14e-11ea-b51e-537032a90354': StringToFloat,
	'f712793d-8ee9-4805-9d4a-8c210cae667a': NumberToString,
	'94e93f42-d05e-45d9-9211-ba903e779f2d': Unit,
	'70972046-ad11-11ea-aaea-0b9067ad19e7': This,
	'feaff5a2-1cbe-4fe8-89e7-421a2b7fc28f': System,
	'b5ea15f4-9bbd-11eb-b623-37aff4a9ce60': Specs,
	'e547c624-d505-485d-8d78-e393c6beb1b4': Spec0,
	'ae1f7fc0-d6e7-489c-94ed-dee71c68dbb7': Spec,
	'3be8272d-310a-4aa2-84a1-71f590a8227a': Spark,
	'f9f93972-0764-4095-9ca2-d18b7d9344d4': Scope,
	'727133c9-3e87-4219-a91e-a257c9b2669b': RemoteShareGraph,
	'57bcdd88-a4f4-49ab-92d4-ed1969895520': RemoteGraph,
	'1b592040-968f-456b-bdb5-b424e08b80f1': New0,
	'b099cf61-6745-4c19-a4be-0e1f19ea4b15': Inspect,
	'b0c25199-c284-4f90-817c-60dc89b15b1c': IdToClass,
	'ef26bb99-42a2-40f9-a537-ae49416e1487': Graph0,
	'60169f42-7d1d-43db-9e24-53990dde80e0': Graph,
	'8383c41e-3f9b-4d04-8380-feb583a1404f': Global,
	'56fb9a32-ad10-11ea-b0f4-3b0ea5e3ac2c': Exec,
	'808f93cd-168d-4f06-9795-6477739a5e51': Env,
	'e2c36c21-e293-40df-9238-5c9ae7a20299': Destroy,
	'546fea11-bbb6-4d20-839b-df0011f528ac': ClassToUnitBundle,
	'2520668c-b279-11ea-ace3-5b84eb02bd7f': Catch,
	'3c284564-985a-403f-bf00-8d43aa805ea9': Bundle1,
	'53825c2f-1aca-40f5-b739-3c60ef5886a8': Bundle0,
	'13d738b9-401d-43c9-852f-e9611545f5bc': Bundle,
	'682c1419-d2cc-489d-b95f-a8b7dacada6c': Tan,
	'b9f90a95-1bfc-4897-9068-2560743821a3': Sin,
	'1a59348c-a25a-11eb-8afe-8bedb0732a89': Sign0,
	'530e83d2-1d61-11eb-b472-53e545a06c92': SQRT,
	'2b59f375-ef06-4ec7-80c2-71a53171ec67': Random,
	'ef4c1d0a-bda1-484e-8fcb-0fdbde195778': Pow,
	'3256e26d-8495-4c9d-8998-5b026691231d': PI,
	'4e63c320-f5a5-4f65-982e-632b5adafa29': Min,
	'e857c770-5a98-4f8d-a0e1-b6cb126071ed': Max,
	'f68b0b2a-7967-445e-86a8-99ebc1e2144c': Log0,
	'3217edcf-2fa1-4dc4-af7c-d6fb607c888d': Floor,
	'62af44dc-17d6-459a-b95f-3b8ce5b48856': Cos,
	'e90dbb0a-880b-42f8-9488-7728910ba7e5': Ceil,
	'e3169d84-6b13-49f9-bae0-bf1652d0d5c9': Atan2,
	'5a5efeaf-79b7-4e7d-9507-09331b339962': Asinh,
	'50195696-e8d3-4b45-9a0a-26f2edf2a6bc': Asin,
	'5a711396-7cdc-4f5c-8b2c-76053a477868': Acosh,
	'c5f518c9-650f-4718-8c19-161496fdc676': Acos,
	'fafc23ce-a259-11eb-b14e-af9d1f579af4': Abs,
	'62a19cd6-04bd-4e46-a72e-4fa3516ad3fa': Or,
	'7d02d638-a311-4ea8-a0c0-d45baf739e0d': Not,
	'407640f7-f1c3-4297-a5ce-baff357a6d31': And,
	'3e5c5856-c721-11ea-b7af-07a978a65cdc': UUID,
	'af3e9b4f-779e-4245-903e-5d69192b1afb': SetUnitPinData,
	'cda93f82-5ffe-498c-b756-c7ff405aafa1': SetUnitPinConstant,
	'f3b9b75b-a84b-4070-b4f1-25e5e48664e4': SetName,
	'7750a781-1aa2-4e78-aa91-67fdbf44c09d': SetMetadata,
	'd36729c6-432f-46e9-8fa1-3fc88de022ff': AddUnitSpec,
	'73967b68-9b4b-44c1-8a19-f505551f6c53': AddUnit0,
	'054adf25-93b2-492c-ada2-f55e70d23c3d': AddPin,
	'6da131ca-d22e-49ae-92ea-0607e7f1ea06': AddMerge,
	'd1e7f8a2-3ef2-4264-a429-79d62e54f0b8': Unplug,
	'76e99304-aa0c-11eb-9bfa-07725a1b4287': SetUnitPinData0,
	'd1d9e6e8-c448-4c31-be19-95fab6b42084': SetUnitPinConstant0,
	'c47d84b2-4207-11eb-a064-a3633d64f05d': RemoveUnit,
	'9a7d8615-9216-47d8-b60b-2bc457dc50e9': RemovePlug,
	'0d93e505-d013-4c95-85d1-ffc424d1be5d': RemovePin,
	'2846ce5f-7f05-4c47-a969-8706b5064bbe': Plug,
	'6364c619-778c-43b6-b574-d475f758aeea': Edit,
	'2fcdd937-62b4-4601-b972-196144d3ab33': BulkEdit,
	'b80d4b5a-40e9-11eb-a2bb-1777d47bf9ae': AddUnit,
	'c460bfe1-253e-4d9f-8572-1ca06557aba9': AddPlug,
	'd1f8bea7-3ef6-42c3-a4fc-b50e7484a823': AddPinToMerge,
	'db3e8175-eef8-45fc-9676-f7f2672eadf1': AddPin0,
	'8fb78908-6b6c-4781-acf1-77632361e48f': AddMerge0,
	'17f6b87d-0b29-4c21-90ff-fc3ba7bee516': SetHours,
	'fb194f3b-b7e6-49c8-a77b-e2c16d6f33d7': SetDate,
	'd58015a1-99c0-4f60-9b6f-5195a17be3fe': GetTime,
	'7b5d35ac-b11e-40cd-a3df-77979409da07': GetDate,
	'939ed573-82b8-4385-ac62-88934e5b76c9': Now,
	'4f390740-7257-4eca-911a-cea985628b59': Date,
	'63605ea1-40e7-47db-9f8f-313dffa6e3c9': TypeOf,
	'2b24877a-3221-4288-9f59-efbf29964368': Stringify0,
	'69323dab-b425-4a2a-b1c7-d7efc723327a': Evaluate,
	'ba38b0af-80c0-49e4-9e39-864396964ccc': Wait,
	'9d853ef5-3fff-474d-a951-6af4237cf4c4': Void,
	'99657eb7-fb94-474e-b03d-4b08c537c0a2': Throw,
	'0f1c7d8c-87a7-44ad-bee5-de37d4800e8f': Push,
	'36329d25-218d-48a5-a06c-1e0525da504f': Plan,
	'835edaa6-d07c-44e4-916d-eb4b9fd8f7b1': Next,
	'49e11645-c25d-4bf7-923d-56817f67b686': Memory,
	'3432494e-fab6-4e9d-a846-0c48a7c429cd': Loop,
	'8a2b756a-25e4-11eb-860d-1f34c850b992': Iterate,
	'06bc3983-44b0-43d6-b041-2e9218ea89c8': If,
	'260d774e-bc89-4027-aa92-cb1985fb312b': Identity,
	'329920ae-7e91-11ea-988e-1b12488c8b89': Default,
	'ff976ac8-c54f-4d37-8c7d-089c271cb433': Constant,
	'bda175a9-a9d2-4282-9b50-1b008ae8a807': NotEqual,
	'e13f3090-62a6-4a3b-8401-c571cbf03526': LessThanEqual,
	'82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35': LessThan,
	'c9e06816-0d2b-43ec-b7c8-d07563e19b6b': GreaterThanEqual,
	'1651ce6b-4db0-4787-9edf-f770b72d253c': GreaterThan,
	'85204bf6-6692-4686-a785-23127c0594b5': Equals,
	'3d59edf2-5fca-4475-9df0-d876e14f990d': XOr,
	'0d656c2e-eb10-45f0-b236-f8916492ca86': Or0,
	'62d0c3e2-cf8b-4415-acfb-cf31739adce5': Not0,
	'be6801c0-02e2-4f76-bcad-b68c80991fad': And0,
	'd4572f1c-83d3-4a3d-be76-fa16578286d2': Sort,
	'c6bf897a-4970-4284-bea2-b4a86186f828': Slice0,
	'f69e88e3-b2c2-481b-b036-a5c0ed7ccccb': Remove,
	'22622778-d64f-47e7-8ceb-d175edcc6562': Put,
	'd9cf4224-39df-434a-85a6-2b143330cbab': Prepend,
	'81006022-e4d0-11ea-902a-fbf9fc5c9246': Pop0,
	'46d98b47-0fa4-409e-bbc6-bb3165d863d8': Length1,
	'104777ec-afb9-4513-9974-53b5528f0d15': Join,
	'7014b684-ce58-4b6a-989d-bd6c047daab5': Insert,
	'32b27ad8-51d9-4767-8b9a-09da5a34f39d': Init,
	'9741cb34-bc83-4ebb-a854-edbe9eb3468f': IndexOf0,
	'609ec474-cd6b-4646-b9b9-5ef4bbb378a7': Fill0,
	'f57f5318-f26f-4b9f-b9e2-dcc022ad7728': Concat0,
	'79f01345-4ed7-47e2-8882-fa3bd282c98a': At,
	'fa7721eb-1dd6-482e-8c7a-6da35b5f88bc': Append1,
	'fa94b179-00e3-4ed1-814e-7938324a833f': Subtract,
	'c5c05c85-f4c1-4b67-ab85-08b61fe67531': Remainder,
	'872be100-f4dc-4246-8eea-6e3da31137b7': Multiply,
	'158d85eb-28b8-4355-b637-28a7ec751233': Divide,
	'6fe452f2-2ec1-4ee2-887d-751c3697e6bf': Add,
	'ba0b8e9e-9d8a-4e83-8be3-04e95129e769': Stringify00,
	'ee184ea6-3c80-4119-919e-290620aafab0': Stringify1,
	'563e92be-ad5e-4a61-a718-9249c3eac51d': ParseJSON,
	'58900411-ccc3-4c5a-86df-86efe6b7e30e': Format,
}